import * as React from "react";
import { Link, NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { InverseDropdown } from './styles'
import { OpoHeaderWrapper } from './opo-menu-styles';
import { Icon } from 'react-icons-kit';
import { ic_lock_outline } from 'react-icons-kit/md/ic_lock_outline';
import usePortalOpo from '@nkr/store/opo/hooks/use-portal-opo';
import MediaQuery from 'react-responsive';

interface IProps extends RouteComponentProps {
    firstName: string,
    lastName: string,
    username: string,
    currentUrl: string
}

const actionCenterItems = [
    { to: '/opo/action-center/to-do', label: 'To-Do' },
    { to: '/opo/action-center/deceased-donor-cases', label: 'DD Cases' },
    { to: '/opo/action-center/living-donor-moves', label: 'LDK Moves' },
    { to: '/opo/action-center/move-tracker', label: 'Move Tracker' },
    // { to: '/opo/action-center/support', label: 'Support (Help Desk)' }
];

const adminSettingsItems = [
    { to: '/opo/settings/admin', label: 'Admin' },
    { to: '/opo/settings/taxes', label: 'Taxes' }
];

const opoSettingsItems = [
    { to: '/opo/settings/profile', label: 'Profile' },
    { to: '/opo/settings/addresses', label: 'Addresses' },
    { to: '/opo/settings/users', label: 'Portal Users' },
    { to: '/opo/settings/contacts', label: 'Contacts' },
    { to: '/opo/settings/packaging', label: 'Packaging' },
];

const OpoMenus = (props: IProps) => {
    const { isAdmin } = usePortalOpo();
    const settingsItems = isAdmin ? [...adminSettingsItems, ...opoSettingsItems] : opoSettingsItems;
    const isActionCenter = actionCenterItems.find(x => x.to == props.location.pathname) != null;
    const isSettings = settingsItems.find(x => x.to == props.location.pathname) != null;
    const initials = `${(props.firstName || '').charAt(0)}${(props.lastName || '').charAt(0)}`.toUpperCase();

    return (
        <MediaQuery minWidth={1112}>
            <OpoHeaderWrapper>
                <div className='navbar navbar-inverse'>
                    <div className='navbar-header'>
                        <a href='https://www.kidneyregistry.org' className='navbar-brand' target='_blank'>
                            <img alt='NKR' src='/images/logo2.png' />
                        </a>
                    </div>
                    <div className='navbar-collapse collapse'>
                        <ul className='nav navbar-nav'>
                            <li className='dropdown'>
                                <a href='#' className={isActionCenter ? 'dropdown-toggle active' : 'dropdown-toggle'} data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Action Center <span className='caret'></span></a>
                                <InverseDropdown className='dropdown-menu'>
                                    {actionCenterItems.map(item =>
                                        <li key={item.to}>
                                            <NavLink to={item.to} activeClassName='active'>{item.label}</NavLink>
                                        </li>
                                    )}
                                </InverseDropdown>
                            </li>
                            <li>
                                <NavLink to={'/opo/billing'}>Billing</NavLink>
                            </li>
                            <li>
                                <NavLink to={'/opo/regulatory-compliance'}>Regulatory Compliance</NavLink>
                            </li>
                             <li>
                                <a href={'https://www.kidneyregistry.com/about/contact-us/'} target='_blank'>Support (Help Desk)</a>
                            </li>
                            <li className='dropdown'>
                                <a href='#' className={isSettings ? 'dropdown-toggle active' : 'dropdown-toggle'} data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Settings <span className='caret'></span></a>
                                <InverseDropdown className='dropdown-menu'>
                                    {isAdmin && (
                                        <>
                                            <li className='dropdown-header'>
                                                <Icon icon={ic_lock_outline} size={12} />
                                                NKR Admin Only
                                            </li>
                                            {adminSettingsItems.map(item =>
                                                <li key={item.to} className='admin-only'>
                                                    <NavLink to={item.to} activeClassName='active'>{item.label}</NavLink>
                                                </li>
                                            )}
                                            <li role='separator' className='divider'></li>
                                        </>
                                    )}
                                    {opoSettingsItems.map(item =>
                                        <li key={item.to}>
                                            <NavLink to={item.to} activeClassName='active'>{item.label}</NavLink>
                                        </li>
                                    )}
                                </InverseDropdown>
                            </li>
                        </ul>

                        <div className='header-tools'>
                            <ul className='nav navbar-nav'>
                                <li className='dropdown'>
                                    <a href='#' className='dropdown-toggle header-user' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>
                                        <span className='avatar'>{initials}</span>
                                        <span className='user-name'>{props.firstName} {props.lastName}</span>
                                        <span className='caret'></span>
                                    </a>
                                    <InverseDropdown className='dropdown-menu dropdown-menu-right'>
                                        <li>
                                            <NavLink to={'/manage-account'} activeClassName='active'>Manage Account</NavLink>
                                            <NavLink to={'/logout?next=' + props.currentUrl} activeClassName='active'>Logout</NavLink>
                                        </li>
                                    </InverseDropdown>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </OpoHeaderWrapper>
        </MediaQuery>
    );
}

export default withRouter(OpoMenus);